module.exports = __webpack_public_path__ + "static/media/calculadora.1541b74e.jpg";